import { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { convexQuery } from '@convex-dev/react-query'
import { api } from 'convex/_generated/api'
import { LoadingScreen } from '@/components/common/LoadingScreen'
import { RewardsPage } from '@/features/rewards/components/RewardsPage'

export const Route = createFileRoute('/_authed/rewards/')({
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(convexQuery(api.rewards.listRewards, {})),
      context.queryClient.ensureQueryData(convexQuery(api.rewards.listRewardItems, {})),
      context.queryClient.ensureQueryData(convexQuery(api.users.getCurrentProfile, {})),
    ])
  },
  pendingComponent: () => <LoadingScreen message="Loading rewards..." />,
  component: RewardsRouteWrapper,
})

function RewardsRouteWrapper() {
  return (
    <Suspense fallback={<LoadingScreen message="Loading rewards..." />}>
      <RewardsPage />
    </Suspense>
  )
}
